module.exports = __webpack_public_path__ + "static/img/UNITLogo.7c7a0e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/UNITLogo.png
// module id = 231
// module chunks = 1